import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { PROMOTION_CACHE_KEYS } from "./keys";

import {
  PromotionListParams,
  PromotionRepository,
} from "@/repositories/promotion";

const promotionRepository = new PromotionRepository();

export const useGetAllPromotions = (params: PromotionListParams) => {
  return useQuery({
    queryKey: PROMOTION_CACHE_KEYS.LIST(params),
    queryFn: () => promotionRepository.findAll(params),
    placeholderData: keepPreviousData,
  });
};
